import { GraphVertex } from '../types';
export default (v: GraphVertex) => v?.entity?._type?.[0] || 'unknown';
